import { Link } from "react-router-dom";
import { Mail, Phone, Globe, MapPin } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function Footer() {
  const settings = useSettings();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="section-inner">
        <div className="footer-grid">
          <div>
            <img className="footer-logo" src="/assets/suvlogo.png" alt={settings.company_name || "SUV Engineers"} />
            <p>
              Government-licensed electrical contractors delivering HT &amp; LT works,
              networking, and turnkey electrical solutions across India.
            </p>
          </div>
          <div>
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div>
            <h4>Services</h4>
            <Link to="/about">HT &amp; LT Works</Link>
            <Link to="/about">Electrical Contracting</Link>
            <Link to="/about">Networking Systems</Link>
            <Link to="/about">ELV &amp; Fire Systems</Link>
          </div>
          <div>
            <h4>Get in Touch</h4>
            {settings.email && (
              <a href={`mailto:${settings.email}`}><Mail size={15} style={{ marginRight: 8, verticalAlign: "-2px" }} />{settings.email}</a>
            )}
            {settings.website && (
              <a href={settings.website.startsWith("http") ? settings.website : `https://${settings.website}`} target="_blank" rel="noreferrer"><Globe size={15} style={{ marginRight: 8, verticalAlign: "-2px" }} />{settings.website.replace(/^https?:\/\//, "")}</a>
            )}
            {settings.address && (
              <span><MapPin size={15} style={{ marginRight: 8, verticalAlign: "-2px" }} />{settings.address}</span>
            )}
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {settings.company_name || "SUV Engineers"}. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
